import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { SIMPLE_CHALLENGE_FRAGMENT } from '../fragments'

const SAVE_CHALLENGES_MUTATION = gql`
  mutation saveChallenges($data: [SimpleChallengeInput!]!) {
    saveChallenges(data: $data) {
      results {
        ...SimpleChallengeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${SIMPLE_CHALLENGE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default SAVE_CHALLENGES_MUTATION
